var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic_off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3999 6.7373C13.3999 5.9123 14.0749 5.2373 14.8999 5.2373C15.7249 5.2373 16.3999 5.9123 16.3999 6.7373L16.3874 11.6248L18.6499 13.8623V6.8623C18.6499 4.7873 16.9749 3.1123 14.8999 3.1123C12.9749 3.1123 11.4124 4.5623 11.1999 6.4248L13.3999 8.6248V6.7373ZM23.6499 14.3623H21.5249C21.5249 15.0873 21.3999 15.7748 21.1874 16.4123L22.7749 17.9998C23.3249 16.8998 23.6499 15.6623 23.6499 14.3623ZM5.4124 4.1873L3.6499 5.9498L11.1499 13.4498V14.3623C11.1499 16.4373 12.8249 18.1123 14.8999 18.1123C15.1874 18.1123 15.4499 18.0748 15.7124 18.0123L17.7874 20.0873C16.8999 20.4998 15.9124 20.7373 14.8999 20.7373C11.4499 20.7373 8.2749 18.1123 8.2749 14.3623H6.1499C6.1499 18.6248 9.5499 22.1498 13.6499 22.7623V26.8623H16.1499V22.7623C17.2874 22.5998 18.3624 22.1998 19.3374 21.6373L24.5874 26.8873L26.3499 25.1248L5.4124 4.1873Z",
    fill: "#E3E3E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic_off.21425e902e385f5d4c73fe69e755eaa1.svg";
export { ForwardRef as ReactComponent };